import { render, staticRenderFns } from "./CoOverlay.vue?vue&type=template&id=03d5fe82&scoped=true&"
import script from "./CoOverlay.vue?vue&type=script&lang=js&"
export * from "./CoOverlay.vue?vue&type=script&lang=js&"
import style0 from "./CoOverlay.vue?vue&type=style&index=0&id=03d5fe82&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d5fe82",
  null
  
)

export default component.exports